export const SINGLE_ANIME_CALL_REQUEST = "SINGLE_ANIME_CALL_REQUEST";
export const SINGLE_ANIME_CALL_SUCCESS = "SINGLE_ANIME_CALL_SUCCESS";
export const SINGLE_ANIME_CALL_FAILURE = "SINGLE_ANIME_CALL_FAILURE";
